import React from "react";
import Top from "../../Top";
import Left from "../../Left";
import { useNavigate } from "react-router-dom";
import { Button, Grid } from "@mui/material";
import Zoom from "react-medium-image-zoom";
import UserProfileDtlsTab from "../UserProfile/UserProfileDtlsTab";
// import CreateIcon from "@mui/icons-material/Create";
// import PlaylistRemoveIcon from "@mui/icons-material/PlaylistRemove";
// import PersonOutlinedIcon from "@mui/icons-material/PersonOutlined";
import UserProfileEditModal from "../UserProfile/UserProfileEditModal";
import CameraAltOutlinedIcon from "@mui/icons-material/CameraAltOutlined";
import EventNoteIcon from "@mui/icons-material/EventNote";
import ArrowForwardIosIcon from "@mui/icons-material/ArrowForwardIos";
import SpatialAudioOffIcon from "@mui/icons-material/SpatialAudioOff";
import ThumbUpIcon from "@mui/icons-material/ThumbUp";
import CommentIcon from "@mui/icons-material/Comment";

// For Modal
import Dialog from "@mui/material/Dialog";
// import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
// import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";
import CloseIcon from "@mui/icons-material/Close";
import swal from "sweetalert";
import {
  makeGetRequest,
  makePostRequest,
  uploadFileRequest,
} from "../../../utils/utils";
// import NoticeBoardAndDiscuTab from "../Dashboard/NoticeBoardAndDiscuTab";
import moment from "moment";
import avtarPic from "../../../assets/Images/avtarPic.png";

// End

function UserProfile() {
  const navigate = useNavigate();

  // For Modal
  const [open, setOpen] = React.useState(false);
  const [scroll] = React.useState("paper");
  const [showLoader, setShowLoader] = React.useState(false);
  const MAX_LENGTH = 100;

  // const handleClickOpen = (scrollType) => () => {
  //   setOpen(true);
  //   setScroll(scrollType);
  // };
  const handleClose = () => {
    setOpen(false);
  };
  const descriptionElementRef = React.useRef(null);

  async function uploadImageOrFile(fileData) {
    const formData = new FormData();
    formData.append("image", fileData);
    var fileUrl;

    await uploadFileRequest("guards/uploadImages", formData).then(
      (response) => {
        fileUrl = response.data.imagepath[0].location;
        console.log(response.data.imagepath[0]);
      }
    );
    return fileUrl;
  }

  function validateImageOrFile(fileData) {
    if (fileData.name.match(/.(jpg|JPG|jpeg|JPEG|png|PNG|gif|GIF)$/i))
      return true;
    else return false;
  }

  async function uploadProfilePic(e) {
    // handle validations
    const file = e.target.files[0];
    console.log("File", file);
    if (validateImageOrFile(file)) {
      var profilePicUrl = await uploadImageOrFile(file);
      console.log("ProfileUrl", profilePicUrl);
      setProfilePic(profilePicUrl);

      makeGetRequest("resident/getbyid/" + localStorage.getItem("userId"))
        .then((response) => {
          if (response.status === 201) {
            let UserData = response.data.data;
            let userObj = response.data.data.user_obj;
            userObj.profile_pic = profilePicUrl;
            response.data.data.user_obj = userObj;

            makePostRequest("resident/update", response.data.data)
              .then((response) => {
                // checked codition if responce is empty
                if (response.data.data !== undefined) {
                  localStorage.setItem("profilePic", profilePicUrl);
                  window.location.reload();
                  // navigate('/ResidentManagement')
                  // a11yProps(1);
                } else {
                }
              })
              .catch((err) => {
                swal("There was an error!", "more error details", "warning");
              });
          }
        })
        .catch((err) => {
          swal("There was an error!", "more error details", "warning");
        });
    } else swal("Please upload a file with image format only", "", "warning");
  }

  const [profilePic, setProfilePic] = React.useState();
  const [postList, setPostList] = React.useState([]);
  const [noticeData, setNoticeData] = React.useState({});

  const [q, setQ] = React.useState("");

  async function getAllNotice() {
    setShowLoader(true);
    setNoticeData({});
    let bodyFormData = {
      searchq: q,
      status: "publish",
      pageNo: 1,
      count: 5,
      notice_visible_flag: "",
    };

    await makePostRequest("commonapis/noticelisting", bodyFormData)
      .then((response) => {
        if (response.status == "201") {
          const data = response.data.data.data;
          if (data.length > 0) {
            setNoticeData(data[0]);
            // detailsNotice(response.data.data.rows[0])
          }
          setShowLoader(false);
        } else {
          setShowLoader(false);
          swal("There was an error!", response.message, "warning");
        }
      })
      .catch((err) => {
        setShowLoader(false);
        swal("There was an error!", "more error details", "warning");
      });
  }

  async function getAllPosts() {
    setShowLoader(true);
    let inputData = {
      searchString: q,
      status: "newtoold",
      pageNo: 1,
      count: 3,
    };
    makePostRequest("post/postListing", inputData)
      .then((response) => {
        if (response.status == "201") {
          const data = response.data.data.data;
          if (data.length > 0) {
            // console.log("Post Listing ", data[0].json_agg);
            // if (data[0].json_agg) {
              setPostList(data);
            // } else {
            //   setPostList([]);
            // }
            setShowLoader(false);
          }else {
            setPostList([]);
            setShowLoader(false);
          }
        } else {
          setShowLoader(false);
          swal("There was an error!", response.message, "warning");
        }
      })
      .catch((err) => {
        setShowLoader(false);
        swal("There was an error!", "more error details", "warning");
      });
  }

  React.useEffect(() => {
    if (open) {
      const { current: descriptionElement } = descriptionElementRef;
      if (descriptionElement !== null) {
        descriptionElement.focus();
      }
    }
    setProfilePic(localStorage.getItem("profilePic"));
    getAllNotice();
    getAllPosts();
  }, [open]);
  // End

  return (
    <>
      <Top />
      <Left />
      <div className="rightContent">
        <Grid container spacing={3} className="mainHeadingLine">
          <Grid item xs={12} md={12} className="oneLineBt">
            <h1 className="panelHeading">My Profile</h1>
            {/* <Button
              className="contentTopLefBt"
                onClick={handleClickOpen("body")}
            >
              Download
            </Button> */}
          </Grid>
          <Grid item xs={12} md={8}>
            <div className="userProfilLeftMain">
              {/* <div className="userTopMain">
                <CreateIcon
                  className="userTopEditIcon"
                  // onClick={handleClickOpen("body")}
                  onClick={() => editResident(localStorage.getItem('userId'))}
                />
              </div> */}
              <div className="userTopProDivOut">
                <div style={{ position: "relative", display: "inline-flex" }}>
                  <div className="camIco">
                    <CameraAltOutlinedIcon />
                    <input
                      type="file"
                      onChange={(event) => uploadProfilePic(event)}
                    />
                  </div>
                  <div className="userTopProDiv">
                    <Zoom>
                      {profilePic?
                      <img src={profilePic} />
                      :
                      <img src={avtarPic} />
                      }
                    </Zoom>
                  </div>
                </div>
              </div>
              <div className="userContMain">
                <UserProfileDtlsTab />
              </div>
            </div>
          </Grid>
          <Grid item xs={12} md={4}>
            <div className="useSideNoticeMain">
              <div className="visitorListNewOut">
                <div className="visitorHead applicationHead">
                  <h3>
                    <EventNoteIcon /> Notice Board
                  </h3>{" "}
                  <span
                    className="userProViewAll"
                    onClick={() => navigate("/NoticeBoardPage")}
                  >
                    View All
                  </span>
                </div>
                <div className="useSideNoticeInner">
                  <div className="contInDiv">
                    <b
                      className="redMo userProReadMore"
                      onClick={() => navigate("/NoticeBoardPage")}
                    >
                      Read More <ArrowForwardIosIcon />
                    </b>
                    <h4>{noticeData.notice_title}</h4>
                    <span>
                      {moment(noticeData.created_at).format("DD-MM-YYYY")}{" "}
                      {moment(noticeData.created_at).format("hh:mm A")}
                    </span>
                    {noticeData.notice_description ? (
                      <p>
                        {noticeData.notice_description.length > MAX_LENGTH ? (
                          <div
                            dangerouslySetInnerHTML={{
                              __html:
                                noticeData.notice_description.substring(
                                  0,
                                  MAX_LENGTH
                                ) + "...",
                            }}
                          ></div>
                        ) : (
                          <div
                            dangerouslySetInnerHTML={{
                              __html: noticeData.notice_description,
                            }}
                          ></div>
                        )}
                      </p>
                    ) : (
                      <></>
                    )}
                  </div>
                </div>
              </div>
            </div>

            <div className="useSideNoticeMain parkSideSocMain">
              <div className="visitorListNewOut">
                <div className="visitorHead applicationHead">
                  <h3>
                    <SpatialAudioOffIcon />{" "}
                    {localStorage.getItem("societyName")}
                  </h3>{" "}
                  <span
                    className="userProViewAll"
                    onClick={() => navigate("/DiscussionForumPage")}
                  >
                    View All
                  </span>
                </div>
                <div className="useSideNoticeInner">
                  <div className="discHeadingPark">
                    <p>Discussion Forum</p>
                  </div>
                  <div className="parkForScroll">
                    {postList ? (
                      <>
                        {postList.map((option, index) => (
                          <>
                            {index < 2 ? (
                              <div className="parkSocityInner">
                                <div className="parkSocityTop">
                                  <div className="parkSocityTopPro">
                                    {option.profile ? (
                                    <Zoom>
                                      <img src={option.profile} />
                                    </Zoom>
                                  ) : (
                                    <Zoom>
                                      <img alt="Remy Sharp" src={avtarPic} />
                                    </Zoom>
                                  )}
                                  </div>
                                  <h4>
                                    {" "}
                                    {option.fname} {option.lname}
                                  </h4>
                                  <div className="parkWi">
                                    <b>{option.contact_no}</b>{" "}
                                    <span>
                                      {moment(option.created_at).format(
                                        "h:mm:ss a"
                                      )}
                                    </span>
                                  </div>
                                  <p className="parContTx">
                                    {option.post_title}
                                  </p>
                                </div>

                                <div className="parkSocialOut">
                                  <div>
                                    <ThumbUpIcon onClick={() => navigate("/DiscussionForumPage")}/>
                                    {option.likecount ? (
                                      <span>{option.likecount} Like</span>
                                    ) : (
                                      <span>0 Like</span>
                                    )}
                                  </div>
                                  <div>
                                    <CommentIcon onClick={() => navigate("/DiscussionForumPage")}/>
                                    {option.maincommentcount ? (
                                      <span>
                                        {option.maincommentcount} Comments
                                      </span>
                                    ) : (
                                      <span>0 Comments</span>
                                    )}
                                  </div>
                                </div>
                              </div>
                            ) : (
                              <></>
                            )}
                          </>
                        ))}
                      </>
                    ) : (
                      <span>No Discussion</span>
                    )}
                  </div>
                  <div className="startNewConOut">
                    <Button
                      className="addBt"
                      onClick={() => navigate("/DiscussionForumPage")}
                    >
                      Start New Conversation
                    </Button>
                  </div>
                </div>
              </div>
            </div>

            {/* <div className="userProfilRightMain">
              <h3 className="userProfilRightHeading">Recent Updates</h3>
              <div className="resentUpdtMain">
                <div className="resentUpdtInner">
                  <div className="resentUpdtRound">
                    <PlaylistRemoveIcon />
                  </div>
                  <div className="resentUpdtCont">
                    <h2>Invoice for Sept has been generated</h2>
                    <span>5/19/12</span>
                  </div>
                </div>

                <div className="resentUpdtInner">
                  <div className="resentUpdtRound">
                    <PersonOutlinedIcon />
                  </div>
                  <div className="resentUpdtCont">
                    <h2>Mr. Sandip joined society</h2>
                    <span>6/21/19</span>
                  </div>
                </div>

                <div className="resentUpdtInner">
                  <div className="resentUpdtRound">
                    <PlaylistRemoveIcon />
                  </div>
                  <div className="resentUpdtCont">
                    <h2>Invoice for Sept has been generated</h2>
                    <span>5/19/12</span>
                  </div>
                </div>

                <div className="resentUpdtInner">
                  <div className="resentUpdtRound">
                    <PersonOutlinedIcon />
                  </div>
                  <div className="resentUpdtCont">
                    <h2>Mr. Sandip joined society</h2>
                    <span>6/21/19</span>
                  </div>
                </div>

                <div className="resentUpdtInner">
                  <div className="resentUpdtRound">
                    <PlaylistRemoveIcon />
                  </div>
                  <div className="resentUpdtCont">
                    <h2>Invoice for Sept has been generated</h2>
                    <span>5/19/12</span>
                  </div>
                </div>

                <div className="resentUpdtInner">
                  <div className="resentUpdtRound">
                    <PersonOutlinedIcon />
                  </div>
                  <div className="resentUpdtCont">
                    <h2>Mr. Sandip joined society</h2>
                    <span>6/21/19</span>
                  </div>
                </div>
              </div>
            </div> */}
          </Grid>
        </Grid>
      </div>

      <div className="modalMain">
        {/* <Button onClick={handleClickOpen("paper")}>scroll=paper</Button>
      <Button onClick={handleClickOpen("body")}>scroll=body</Button> */}
        <Dialog
          open={open}
          // onClose={handleClose}
          scroll={scroll}
          aria-labelledby="scroll-dialog-title"
          aria-describedby="scroll-dialog-description"
        >
          <DialogTitle id="scroll-dialog-title" className="modalHeading">
            <span>Edit Profile</span>
            <CloseIcon className="modalCloseBt" onClick={handleClose} />
          </DialogTitle>
          <DialogContent dividers={scroll === "paper"}>
            <div className="modalInnerCont">
              <UserProfileEditModal />
            </div>
          </DialogContent>
        </Dialog>
      </div>
      {showLoader && (
        <div className="loaderOter" id="loaderId">
          <div className="wrapper">
            <div className="circle"></div>
            <div className="circle"></div>
            <div className="circle"></div>
            <div className="shadow"></div>
            <div className="shadow"></div>
            <div className="shadow"></div>
            <span>Loading</span>
          </div>
        </div>
      )}
    </>
  );
}

export default UserProfile;
